import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function PatientHistoryIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.38387 10.1982C2.57169 10.6896 0.442195 11.693 1.7392 12.9486C2.37277 13.562 3.07842 14.0006 3.96558 14.0006H9.02794C9.91508 14.0006 10.6207 13.562 11.2543 12.9486C12.5513 11.693 10.4218 10.6896 9.60961 10.1982C7.70508 9.0459 5.28843 9.0459 3.38387 10.1982Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8.9974 4.66667C8.9974 6.13943 7.80346 7.33333 6.33073 7.33333C4.85797 7.33333 3.66406 6.13943 3.66406 4.66667C3.66406 3.19391 4.85797 2 6.33073 2C7.80346 2 8.9974 3.19391 8.9974 4.66667Z"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M11.3301 3.33398H14.6634"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.3301 5.33398H14.6634"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.3301 7.33398H14.6634"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
